// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../../google/protobuf/Timestamp";
import { WireType, } from "../../../../runtime/wire/index";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        createdAt: undefined,
        fulfilledAt: undefined,
        withdrawVoidAt: undefined,
        withdrawCancelAt: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.createdAt !== undefined)
        result.createdAt = encodeJson_1(value.createdAt);
    if (value.fulfilledAt !== undefined)
        result.fulfilledAt = encodeJson_1(value.fulfilledAt);
    if (value.withdrawVoidAt !== undefined)
        result.withdrawVoidAt = encodeJson_1(value.withdrawVoidAt);
    if (value.withdrawCancelAt !== undefined)
        result.withdrawCancelAt = encodeJson_1(value.withdrawCancelAt);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.createdAt !== undefined)
        result.createdAt = decodeJson_1(value.createdAt);
    if (value.fulfilledAt !== undefined)
        result.fulfilledAt = decodeJson_1(value.fulfilledAt);
    if (value.withdrawVoidAt !== undefined)
        result.withdrawVoidAt = decodeJson_1(value.withdrawVoidAt);
    if (value.withdrawCancelAt !== undefined)
        result.withdrawCancelAt = decodeJson_1(value.withdrawCancelAt);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.createdAt !== undefined) {
        const tsValue = value.createdAt;
        result.push([1, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.fulfilledAt !== undefined) {
        const tsValue = value.fulfilledAt;
        result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.withdrawVoidAt !== undefined) {
        const tsValue = value.withdrawVoidAt;
        result.push([3, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.withdrawCancelAt !== undefined) {
        const tsValue = value.withdrawCancelAt;
        result.push([4, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.createdAt = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.fulfilledAt = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.withdrawVoidAt = value;
    }
    field: {
        const wireValue = wireFields.get(4);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.withdrawCancelAt = value;
    }
    return result;
}
